import React, { useState } from "react";

import { Accordion, Typography } from "clearsense-ui/components";

import InformationCard from "./InformationCard";

import ExpandAllCollapseAll from "../RecordDetails/ExpandAllCollapseAll";
import TabHeader from "../RecordDetails/TabHeader";

const SurvivorshipDomainRecord = ({
  recordDetails,
  businessRules,
  searchIdentifier,
}) => {
  const [expandedAccordions, setExpandedAccordions] = useState(0);

  const providerData =
    recordDetails?.result?.[0]?.truth_system_value &&
    JSON.parse(recordDetails?.result?.[0]?.truth_system_value).sort(
      (a, b) => a?.sort_order - b?.sort_order
    );

  const generateExpandedHierarchyIndices = () =>
    Array(providerData.length - 1).keys();

  return (
    <div>
      {!!providerData?.length && (
        <div className="flex flex-col space-y-2 items-center border bg-white p-8">
          <div className="w-full">
            <TabHeader
              recordDetails={recordDetails}
              searchIdentifier={searchIdentifier}
            />
            <div className="flex justify-end items-center">
              <ExpandAllCollapseAll
                onExpand={() =>
                  setExpandedAccordions([...generateExpandedHierarchyIndices()])
                }
                onCollapse={() => setExpandedAccordions([])}
              />
            </div>
          </div>

          <div className="w-full px-8 py-4 border divide-y">
            <Accordion multipleExpanded defaultActiveKey={expandedAccordions}>
              {providerData
                ?.filter(section =>
                  Object.keys(section)?.[0]?.includes("Information")
                )
                ?.map((section, idx) => (
                  <Accordion.Item
                    key={idx}
                    title={
                      <Typography
                        style="h3"
                        type="semibold"
                        className="text-shades-darkest"
                      >
                        {Object.keys(section)?.[0]}
                      </Typography>
                    }
                  >
                    <InformationCard
                      section={section}
                      number={idx}
                      businessRules={businessRules}
                      expandedAccordions={expandedAccordions}
                      parentHierarchyNumber={idx}
                    />
                  </Accordion.Item>
                ))}
            </Accordion>
          </div>
        </div>
      )}
    </div>
  );
};

export default SurvivorshipDomainRecord;
